export function getLocale() {
    return window.navigator.language || 'en';
}